<template>
  <div>
    <ThemeSelector />
    <PulsBackground>
      <div class="p-2">
        <div class="container-xl">
          <router-view />
        </div>
      </div>
    </PulsBackground>
  </div>
</template>

<script>
import {
  PulsBackground,
  ThemeSelector
} from '@puls-solutions/puls-ui-components-vue3'

export default {
  name: 'App',
  components: {
    PulsBackground,
    ThemeSelector
  },
  computed: {
    selectedLocale() {
      return this.$route.query && this.$route.query.l // ? this.$route.query.l : 'en'
    }
  },
  watch: {
    selectedLocale() {
      this.$i18n.locale = this.selectedLocale
    }
  },
  mounted() {
    if (this.selectedLocale) {
      this.$i18n.locale = this.selectedLocale
    } else {
      this.$i18n.locale = 'en'
    }
  },
  methods: {}
}
</script>

<style>
body {
  background-color: transparent !important;
}

.main-panel {
  overflow: scroll;
}
.background {
  background: url('./assets/img/bgwave.svg');
  background-size: cover;
  background-attachment: fixed;

  height: 100%;
  min-height: 100vh;
}
</style>
